import React from 'react';

export default function(props){
    return(
        <>
        <p className="mobileTitle">Mis Chats</p>
        </>
    )
}